module.exports = __webpack_public_path__ + "static/media/icon_member.acd4fac1.svg";